import { Types } from '@store/types';

import ApiClient from '@lib/apiClient';

export const fetchPhotographyRequestByStatus =
	(params = '?page=0&size=15') =>
	async (dispatch) => {
		await ApiClient.GET('fetchPhotographyRequest', params)
			.then((response) => {
				dispatch({
					type: Types.FETCH_ALL_PHOTOGRAPHY_BY_STATUS,
					payload: response.data
				});
				return response;
			})
			.catch((err) => {
				return err;
			});
	};

export const setPhotographyFilterField = (params) => async (dispatch) => {
	await dispatch({
		type: Types.SET_PHOTOGRAPHY_FILTER_DATA,
		payload: params
	});
};

export const clearPhotography = () => async (dispatch) => {
	await dispatch({
		type: Types.CLEAR_PHOTOGRAPHY,
		payload: {}
	});
};

export const fetchPhotographyCount = (params) => async (dispatch) => {
	await ApiClient.GET('fetchPhotographyCount', params).then((response) => {
		dispatch({
			type: Types.SET_PHOTOGRAPHY_COUNT,
			payload: response.data
		});
	});
};
